// SLEEKEND — un solo archivo para toda la interactividad propia.
document.addEventListener('DOMContentLoaded', function () {
  initReveals();
  initContadores();
  initMarquesina();
  initVariantesProducto();
  initAddToCartToast();
  initAntesDespues();
});

function bkMoneyFmt(cents, currency) {
  return (cents / 100).toLocaleString(document.documentElement.lang || 'es', {
    style: 'currency',
    currency: currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR',
  });
}

function initReveals() {
  var els = document.querySelectorAll('.bk-reveal, .bk-reveal-scale');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('bk-visible'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var delay = entry.target.getAttribute('data-bk-delay') || 0;
        setTimeout(function () { entry.target.classList.add('bk-visible'); }, Number(delay));
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function (el) { io.observe(el); });
}

function initContadores() {
  var els = document.querySelectorAll('[data-bk-count]');
  if (!els.length) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var target = parseFloat(el.getAttribute('data-bk-count'));
      var suffix = el.getAttribute('data-bk-suffix') || '';
      var dur = 1400;
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = (target % 1 === 0 ? Math.round(target * eased) : (target * eased).toFixed(1)) + suffix;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
      io.unobserve(el);
    });
  }, { threshold: 0.5 });
  els.forEach(function (el) { io.observe(el); });
}

function initMarquesina() {
  document.querySelectorAll('.bk-marquee').forEach(function (track) {
    if (track.dataset.bkCloned) return;
    track.dataset.bkCloned = '1';
    var clone = track.innerHTML;
    track.insertAdjacentHTML('beforeend', clone);
  });
}

function initVariantesProducto() {
  var root = document.querySelector('[data-bk-producto]');
  if (!root) return;
  var dataEl = root.querySelector('[data-bk-variantes-json]');
  if (!dataEl) return;
  var variants;
  try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var optionInputs = root.querySelectorAll('[data-bk-option]');
  var idInput = root.querySelector('[data-bk-variant-id]');
  var priceEl = root.querySelector('[data-bk-price]');
  var compareEl = root.querySelector('[data-bk-compare]');
  var addBtn = root.querySelector('[data-bk-add]');
  var moneyFmt = bkMoneyFmt;

  var galeria = root.querySelector('[data-bk-galeria]');
  var track = galeria ? galeria.querySelector('[data-bk-galeria-track]') : null;
  var slides = track ? Array.prototype.slice.call(track.querySelectorAll('[data-bk-galeria-slide]')) : [];
  var thumbs = galeria ? galeria.querySelectorAll('[data-bk-galeria-thumb]') : [];
  var prevBtn = galeria ? galeria.querySelector('[data-bk-galeria-prev]') : null;
  var nextBtn = galeria ? galeria.querySelector('[data-bk-galeria-next]') : null;
  var suppressScrollSync = false;
  var settleTimer = null;

  function currentSelection() {
    var sel = [];
    optionInputs.forEach(function (group) {
      var checked = group.querySelector('input:checked, option:checked');
      if (checked) sel.push(checked.value);
    });
    return sel;
  }

  function findVariant(sel) {
    return variants.find(function (v) {
      return v.options.length === sel.length && v.options.every(function (val, i) { return val === sel[i]; });
    });
  }

  function highlightThumb(i) {
    thumbs.forEach(function (t, ti) { t.classList.toggle('bk-thumb--active', ti === i); });
  }

  function goToSlide(index) {
    if (!track || !slides[index]) return;
    suppressScrollSync = true;
    track.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
    highlightThumb(index);
    clearTimeout(settleTimer);
    settleTimer = setTimeout(function () { suppressScrollSync = false; }, 500);
  }

  function goToColor(selValue) {
    var label = root.querySelector('[data-bk-swatch="' + selValue + '"]');
    var key = label ? label.getAttribute('data-bk-key') : null;
    if (!key) return;
    var index = slides.findIndex(function (s) { return s.getAttribute('data-bk-key') === key; });
    if (index > -1) goToSlide(index);
  }

  function setColorSelection(key) {
    var label = root.querySelector('[data-bk-swatch][data-bk-key="' + key + '"]');
    var input = label ? label.querySelector('input') : null;
    if (!input || input.checked) return;
    input.checked = true;
    update(false);
  }

  function update(syncGallery) {
    var sel = currentSelection();
    var variant = findVariant(sel);
    if (!variant) return;
    if (idInput) idInput.value = variant.id;
    if (priceEl) priceEl.textContent = moneyFmt(variant.price);
    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = moneyFmt(variant.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
    if (addBtn) {
      if (variant.available) {
        addBtn.disabled = false;
        addBtn.textContent = addBtn.getAttribute('data-bk-label-add') || addBtn.textContent;
      } else {
        addBtn.disabled = true;
        addBtn.textContent = addBtn.getAttribute('data-bk-label-sold-out') || 'Agotado';
      }
    }
    root.querySelectorAll('[data-bk-swatch]').forEach(function (sw) {
      sw.classList.toggle('bk-swatch--active', sel.indexOf(sw.getAttribute('data-bk-swatch')) > -1);
    });
    if (syncGallery !== false && sel[0]) goToColor(sel[0]);
  }

  root.addEventListener('change', function (e) {
    if (e.target.matches('[data-bk-option] input, [data-bk-option] select')) update(true);
  });
  root.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-bk-swatch-input]');
    if (sw) {
      sw.checked = true;
      update(true);
    }
  });

  if (track && slides.length) {
    prevBtn && prevBtn.addEventListener('click', function () {
      var current = Math.round(track.scrollLeft / track.clientWidth);
      goToSlide(Math.max(0, current - 1));
    });
    nextBtn && nextBtn.addEventListener('click', function () {
      var current = Math.round(track.scrollLeft / track.clientWidth);
      goToSlide(Math.min(slides.length - 1, current + 1));
    });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        goToSlide(Number(t.getAttribute('data-bk-index')));
      });
    });
    var scrollTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        if (suppressScrollSync) return;
        var width = track.clientWidth || 1;
        var index = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / width)));
        highlightThumb(index);
        var key = slides[index].getAttribute('data-bk-key');
        if (key) setColorSelection(key);
      }, 130);
    });
  }

  update(false);
}

function bkShipBarHTML(totalCents, currency, umbralCents, textoFalta, textoListo) {
  var pct = Math.min(100, Math.round((totalCents / umbralCents) * 100));
  var msg;
  if (totalCents >= umbralCents) {
    msg = textoListo;
  } else {
    var restante = bkMoneyFmt(umbralCents - totalCents, currency);
    msg = (textoFalta || '').replace('[importe]', '<strong>' + restante + '</strong>');
  }
  return (
    '<div class="bk-shipbar-track"><div class="bk-shipbar-fill" style="width:' + pct + '%;"></div></div>' +
    '<p class="bk-shipbar-msg">' + msg + '</p>'
  );
}

function initAddToCartToast() {
  var root = document.querySelector('[data-bk-producto]');
  if (!root) return;
  var form = root.querySelector('form[action*="/cart/add"]');
  if (!form) return;

  var umbral = Number(root.getAttribute('data-bk-envio-umbral')) || 4000;
  var textoFalta = root.getAttribute('data-bk-envio-falta') || '';
  var textoListo = root.getAttribute('data-bk-envio-listo') || '';
  var toastTitulo = root.getAttribute('data-bk-toast-titulo') || '';
  var lblVerCarrito = root.getAttribute('data-bk-toast-ver-carrito') || '';
  var lblSeguir = root.getAttribute('data-bk-toast-seguir') || '';

  var toast = document.querySelector('.bk-toast-cart');
  if (!toast) {
    toast = document.createElement('div');
    toast.className = 'bk-toast-cart';
    toast.setAttribute('role', 'status');
    document.body.appendChild(toast);
  }
  var hideTimer = null;

  function renderToast(item, cart) {
    toast.innerHTML =
      '<div class="bk-toast-cart__head"><p class="bk-toast-cart__title">' + toastTitulo + '</p>' +
      '<button type="button" class="bk-toast-cart__close" aria-label="Cerrar">' +
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M5 5l14 14M19 5L5 19"/></svg></button></div>' +
      '<div class="bk-toast-cart__item">' +
      (item.image ? '<img src="' + item.image + '" alt="">' : '') +
      '<p>' + item.product_title + (item.variant_title ? ' — ' + item.variant_title : '') + '<br><strong>' + bkMoneyFmt(item.final_line_price, cart.currency) + '</strong></p>' +
      '</div>' +
      '<div class="bk-toast-cart__actions">' +
      '<a href="/cart" class="bk-btn bk-btn--ghost">' + lblVerCarrito + '</a>' +
      '<button type="button" class="bk-btn" data-bk-toast-seguir>' + lblSeguir + '</button>' +
      '</div>';
    toast.classList.add('bk-toast-visible');
    clearTimeout(hideTimer);
    hideTimer = setTimeout(closeToast, 7000);
  }

  function closeToast() {
    toast.classList.remove('bk-toast-visible');
  }

  toast.addEventListener('click', function (e) {
    if (e.target.closest('.bk-toast-cart__close') || e.target.closest('[data-bk-toast-seguir]')) closeToast();
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var addBtn = form.querySelector('[data-bk-add]');
    var addLabel = addBtn ? addBtn.textContent : '';
    if (addBtn) { addBtn.disabled = true; addBtn.textContent = '…'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: form.querySelector('[name="id"]').value, quantity: 1 }),
    })
      .then(function (res) { return res.json(); })
      .then(function (item) {
        if (item.status) throw new Error(item.description || 'error');
        if (item.items && item.items.length) item = item.items[0];
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          renderToast(item, cart);
          var bubble = document.querySelector('.cart-count-bubble span[aria-hidden]');
          if (bubble) bubble.textContent = cart.item_count;
        });
      })
      .catch(function () {
        form.submit();
      })
      .finally(function () {
        if (addBtn) { addBtn.disabled = false; addBtn.textContent = addLabel; }
      });
  });
}

function initAntesDespues() {
  document.querySelectorAll('[data-bk-antesdespues]').forEach(function (frame) {
    function setPct(pct) {
      pct = Math.max(0, Math.min(100, pct));
      frame.style.setProperty('--bk-ad-x', pct + '%');
      frame.setAttribute('aria-valuenow', Math.round(pct));
    }
    function pctFromEvent(e) {
      var rect = frame.getBoundingClientRect();
      var x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
      return (x / rect.width) * 100;
    }
    var dragging = false;
    var hintDone = false;
    var hintTimers = [];

    function cancelHint() {
      hintDone = true;
      hintTimers.forEach(function (t) { clearTimeout(t); });
      frame.classList.remove('bk-ad-hint');
    }

    function playHint() {
      if (hintDone) return;
      hintDone = true;
      frame.classList.add('bk-ad-hint');
      hintTimers.push(setTimeout(function () { setPct(64); }, 350));
      hintTimers.push(setTimeout(function () { setPct(36); }, 1550));
      hintTimers.push(setTimeout(function () { setPct(50); }, 2750));
      hintTimers.push(setTimeout(function () { frame.classList.remove('bk-ad-hint'); }, 3900));
    }

    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var hintIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            playHint();
            hintIo.unobserve(frame);
          }
        });
      }, { threshold: 0.5 });
      hintIo.observe(frame);
    }

    frame.addEventListener('pointerdown', function (e) {
      cancelHint();
      dragging = true;
      frame.setPointerCapture(e.pointerId);
      setPct(pctFromEvent(e));
    });
    frame.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      setPct(pctFromEvent(e));
    });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (evt) {
      frame.addEventListener(evt, function () { dragging = false; });
    });
    frame.addEventListener('keydown', function (e) {
      var current = parseFloat(frame.style.getPropertyValue('--bk-ad-x')) || 50;
      if (e.key === 'ArrowLeft') { setPct(current - 4); e.preventDefault(); }
      if (e.key === 'ArrowRight') { setPct(current + 4); e.preventDefault(); }
    });
  });
}

